import PlainUser from './PlainUser'

export default class Company {
  constructor() {
    this.legal_name = ''
    this.trading_name = ''
    this.user = new PlainUser
    this.controlled_by_companies = []
    this.subscriptions = []
    this.create_user = false
    this.is_setup = false
    this.is_searchable = false
  }
}
